import { hapticFeedback } from '@tma.js/sdk';

/**
 * Хаптика — ТОЛЬКО дополнение к визуальному отклику, никогда не замена.
 * На десктопе и в вебе все эти вызовы — no-op, поэтому счётчик,
 * полагающийся только на вибрацию, там просто не даёт обратной связи.
 */

function safe(fn: () => void): void {
  try {
    if (hapticFeedback.isSupported()) fn();
  } catch {
    /* хаптика необязательна — молча пропускаем */
  }
}

/** Обычный тап счётчика */
export function tapFeedback(): void {
  safe(() => hapticFeedback.impactOccurred('light'));
}

/**
 * Для азкаров со 100 повторениями частая impact-вибрация утомляет,
 * а часть Android-клиентов ещё и отстаёт очередью при быстром тапе.
 * selectionChanged — самая деликатная.
 */
export function tapFeedbackSubtle(): void {
  safe(() => hapticFeedback.selectionChanged());
}

/** Счётчик обнулился — азкар прочитан нужное число раз */
export function zikrDoneFeedback(): void {
  safe(() => hapticFeedback.impactOccurred('rigid'));
}

/** Весь набор пройден */
export function setCompleteFeedback(): void {
  safe(() => hapticFeedback.notificationOccurred('success'));
}
